import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

const initialState = {
  notifications: [],
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    enqueueSnackbar: ({ notifications }, { payload }) => {
      payload.options.key = uuidv4();
      notifications.push(payload);
    },
    closeSnackbar: ({ notifications }, { payload }) => {
      if (payload.dismissAll) {
        notifications.forEach((notification) => {
          notification.dismissed = true;
        });
      } else {
        const notificationToUpdateIndex = notifications.findIndex(
          ({ options: { key } }) => key === payload.key,
        );
        notifications[notificationToUpdateIndex].dismissed = true;
      }
    },
    removeSnackbar: ({ notifications }, { payload }) => {
      const notificationToRemoveIndex = notifications.findIndex(
        ({ options: { key } }) => key === payload.key,
      );
      notifications.splice(notificationToRemoveIndex, 1);
    },
  },
});

export const {
  enqueueSnackbar,
  closeSnackbar,
  removeSnackbar,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
